import * as React from 'react';
import { observer } from 'mobx-react';
import CartService from '../../services/CartService';
import CountryService from '../../services/CountryService';
import { NoticeText } from '../Header/components/NoticeBar/NoticeBar';

const CustomsWarning = observer(() => {
  const customer = CartService.GetInstance().customerData as any;
  const country = customer && (customer.AnotherDeliveryAddress === true ? customer._DeliveryAddressCountry : customer._AddressCountry);

  if (!CountryService.GetInstance().isCustomsNoticeRequired(country)) {
    return null;
  }

  return (
    <div className="customs-warning" role="note">
      <i className="customs-warning__icon" aria-hidden="true">
        i
      </i>
      <p className="customs-warning__text">
        <NoticeText />
      </p>
    </div>
  );
});

export default CustomsWarning;



// WEBPACK FOOTER //
// ./src/components/CustomsWarning/CustomsWarning.tsx